import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './shared/theme/tokens.css'
import App from './app/App';
import reportWebVitals from './reportWebVitals';
import {AppThemeProvider} from "./providers/AppThemeProvider";
import {AuthProvider} from "./shared/auth/AuthContext";
import {BrowserRouter} from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <BrowserRouter>
            <AuthProvider>
                <AppThemeProvider
                    primaryColor="#0f766e"
                    accentColor="#14b8a6"
                    companyName="BusiFarm"
                    children=<App />
                />
            </AuthProvider>
        </BrowserRouter>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
